import {useCallback, useEffect, useState} from 'react';

function useAudioPlayer(url: string) {
  const [duration, setDuration] = useState<number>();
  const [curTime, setCurTime] = useState<number>(0);
  const [playing, setPlaying] = useState(false);
  const [clickedTime, setClickedTime] = useState<number>();

  const setAudioData = useCallback(() => {
    // Create an instance of AudioContext
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();

    // Open an Http Request
    const request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.responseType = 'arraybuffer';
    request.onload = function () {
      audioContext.decodeAudioData(request.response, function (buffer) {
        // Obtain the duration in seconds of the audio file (with milliseconds as well, a float value)
        const duration = buffer.duration;
        setDuration(duration);
      });
    };

    // Start Request
    request.send();
  }, [url]);

  useEffect(() => {
    const audio = document.getElementById(url) as HTMLAudioElement;
    // state setters wrappers
    const setAudioTime = () => setCurTime(audio.currentTime);

    // DOM listeners: update React state on DOM events
    audio.addEventListener('loadeddata', setAudioData);
    audio.addEventListener('timeupdate', setAudioTime);
    audio.addEventListener('ended', () => {
      setPlaying(false);
      setCurTime(0);
    });

    // listener pause the song if another song gets started
    audio.addEventListener('pause', () => {
      setPlaying(false);
    });

    // React state listeners: update DOM on React state changes
    if (playing) {
      const allAudio = document.getElementsByTagName('audio');
      Array(allAudio.length)
        .fill({})
        .forEach((_, idx) => {
          const src = allAudio.item(idx);
          if (!src?.paused) allAudio.item(idx)?.pause(); // if any of the songs are playing, then pause it
        });

      audio.play();
    } else {
      audio.pause();
    }

    if (clickedTime && clickedTime !== curTime) {
      audio.currentTime = clickedTime;
      setClickedTime(undefined);
    }

    // effect cleanup
    return () => {
      audio.removeEventListener('loadeddata', setAudioData);
      audio.removeEventListener('timeupdate', setAudioTime);
    };
  }, [url, playing]);

  return {
    curTime,
    duration,
    playing,
    setPlaying,
    setClickedTime,
  };
}

export default useAudioPlayer;
